import { render, staticRenderFns } from "./componentCGVHott.vue?vue&type=template&id=b76897ce"
import script from "./componentCGVHott.vue?vue&type=script&lang=js"
export * from "./componentCGVHott.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports